// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__zGJ0L","bgimg":"PageHeader_bgimg__0BP1Z"};